import { Component, OnInit, OnChanges, Input, SimpleChanges, ContentChild, EventEmitter, Output } from '@angular/core';
import { AsideContentComponent } from './aside-content/aside-content.component';
import { MainContentComponent } from './main-content/main-content.component';

@Component({
  selector: 'app-push-aside-content',
  templateUrl: './app-push-aside-content.component.html',
  styleUrls: ['./app-push-aside-content.component.scss']
})
export class AppPushAsideContentComponent implements OnInit, OnChanges {
  @Input() showAside = false;
  @Input() asideWidth: string;
  @Input() overlayMain = true;
  @Input() squeezeMain = false;
  @Output() overlayClose = new EventEmitter<void>();
  @ContentChild(AsideContentComponent) private asideContentComponent: AsideContentComponent;
  @ContentChild(MainContentComponent) private mainContentComponent: MainContentComponent;
  mainTransformedState: string;

  constructor() { }

  ngOnInit() {
    this.mainTransformedState = this.squeezeMain ? 'squeezed' : 'pushed';
    this.asideContentComponent.open = this.showAside ? 'active' : 'inactive';
    this.asideContentComponent.width = this.asideWidth;
    this.mainContentComponent.asideOpen = this.showAside ? this.mainTransformedState : 'full';
    this.mainContentComponent.asideWidth = this.asideWidth;
    this.mainContentComponent.overlayClickAction = () => {
      this.overlayClose.emit();
      this.asideContentComponent.open = 'inactive';
    };
  }

  ngOnChanges(changes: SimpleChanges) {
    this.asideContentComponent.open = changes.showAside.currentValue ? 'active' : 'inactive';
    this.mainContentComponent.asideOpen = changes.showAside.currentValue ? this.mainTransformedState : 'full';
    this.mainContentComponent.overlay = this.overlayMain ?
      changes.showAside.currentValue : false;
  }
}

